import { GetServiceOptionsResponse } from '@/api';
import { ServiceOptionsData } from '../models';

const fetchOptions = (
  response: GetServiceOptionsResponse,
): ServiceOptionsData => {
  const { data } = response;
  return data;
};

export { fetchOptions };
